import { render, staticRenderFns } from "./TenancyViewInformation.vue?vue&type=template&id=7464e106&scoped=true&"
import script from "./TenancyViewInformation.vue?vue&type=script&lang=js&"
export * from "./TenancyViewInformation.vue?vue&type=script&lang=js&"
import style0 from "./TenancyViewInformation.vue?vue&type=style&index=0&id=7464e106&lang=scss&scoped=true&"
import style1 from "./TenancyViewInformation.vue?vue&type=style&index=1&id=7464e106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7464e106",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7464e106')) {
      api.createRecord('7464e106', component.options)
    } else {
      api.reload('7464e106', component.options)
    }
    module.hot.accept("./TenancyViewInformation.vue?vue&type=template&id=7464e106&scoped=true&", function () {
      api.rerender('7464e106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/view/TenancyViewInformation.vue"
export default component.exports